import React from "react";
import InnovationsSection from "../components/innovationsSection";
import AppNav from "../components/appNav";
import Footer from "../components/footer";
import Hero from "../components/hero";
import { useTranslation } from "react-i18next";

const ServicesPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-paper text-ink">
      <header className="sticky top-0 z-50 bg-paper/95 backdrop-blur-[2px] border-b border-ink-14">
        <AppNav />
      </header>
      <main>
        <Hero
          title={t("Services that own the future.")}
          text={t("White-label modules across blockchain, AI, analytics, and mobile — built to ship and to scale.")}
        />
        <InnovationsSection />
        <Footer />
      </main>
    </div>
  );
};

export default ServicesPage;
